import { render, staticRenderFns } from "./TourExitButton.vue?vue&type=template&id=0f7437e8&scoped=true"
import script from "./TourExitButton.vue?vue&type=script&lang=js"
export * from "./TourExitButton.vue?vue&type=script&lang=js"
import style0 from "./TourExitButton.vue?vue&type=style&index=0&id=0f7437e8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7437e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f7437e8')) {
      api.createRecord('0f7437e8', component.options)
    } else {
      api.reload('0f7437e8', component.options)
    }
    module.hot.accept("./TourExitButton.vue?vue&type=template&id=0f7437e8&scoped=true", function () {
      api.rerender('0f7437e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tours/TourExitButton.vue"
export default component.exports